import {
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Label,
  Input,
  Container,
  Row,
  Col,
  Button,
  Collapse,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import { GENDER_OPTIONS } from "components/constant";
import AdminHeader from "components/Headers/AdminHeader";
import {
  REGEX,
  SELECT_CUSTOM_STYLES,
  MAX_PHOTO_SIZE
} from "constants/CommonConstants";
import React, { useState, useEffect, useContext, useMemo } from "react";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { NotificationContext } from "components/CommonComponents/NotificationProvider";
import { urlDecodedId } from "components/CommonComponents/encodeDecodeFunction";
import { addTrainee, editTrainee, getTraineeDetailByID } from "action/trainee";
import {
  TRAINEE_TYPE_OPTIONS,
  TRAINEE_CATEGORY_OPTIONS,
} from "components/constant";
import {
  getStates,
  getCities,
  getChannelPartnerList,
} from "action/channelPartner";
import { humanReadableToInputDate } from "components/CommonComponents/CommonFunctions";
import CreatableSelect from "components/CommonComponents/CreatableSelect";
import AddNewCityModal from "components/CommonComponents/AddNewCityModal";
import { addCity } from "action/channelPartner";
import DatePicker from "react-datepicker";
import { format } from "date-fns";
import { fieldToSectionMap, sectionLabels } from "components/constant";

const initialFields = {
  firstName: {
    value: "",
    error: "",
    isChanged: false,
  },
  lastName: {
    value: "",
    error: "",
    isChanged: false,
  },
  email: {
    value: "",
    error: "",
    isChanged: false,
  },
  mobile: {
    value: "",
    error: "",
    isChanged: false,
  },
  dob: {
    value: "",
    error: "",
    isChanged: false,
  },
  gender: {
    value: "",
    error: "",
    isChanged: false,
  },
  // role: {
  //   value: ROLE_OPTIONS.find((opt) => opt.value === "TRAINEE"),
  //   error: "",
  // },
  // loginMethod: {
  //   value: "",
  //   error: "",
  // },
  state: {
    value: "",
    error: "",
    isChanged: false,
  },
  addressLine1: {
    value: "",
    error: "",
    isChanged: false,
  },
  addressLine2: {
    value: "",
    error: "",
    isChanged: false,
  },
  landmark: {
    value: "",
    error: "",
    isChanged: false,
  },
  city: {
    value: "",
    error: "",
    isChanged: false,
  },
  pincode: {
    value: "",
    error: "",
    isChanged: false,
  },
  traineeType: {
    value: "",
    error: "",
    isChanged: false,
  },
  traineeCategory: {
    value: "",
    error: "",
    isChanged: false,
  },
  channelPartner: {
    value: "",
    error: "",
    isChanged: false,
  },
  status: {
    value: "ACTIVE",
    error: "",
    isChanged: false,
  },
  profilePhoto: {
    value: null,
    error: "",
  },
  preRequisitesDocuments: {
    value: [],
    error: "",
  },
  organizationName: {
    value: "",
    error: "",
    isChanged: false,
  },
  governmentID: {
    value: "",
    error: "",
    isChanged: false,
  },
  deleteProfilePhoto: {
    value: false,
    error: "",
  },
  deletedDocumentIds: {
    value: [],
    error: "",
  },
};

function AddTrainee() {
  const dispatch = useDispatch();
  const authData = JSON.parse(localStorage.getItem("p") || "{}");
  const role = authData?.role;

  const { id } = useParams();
  const { notify } = useContext(NotificationContext);
  const navigate = useNavigate();
  const location = useLocation();
  const mode = location.state?.mode || "add";
  const decodedId = id ? urlDecodedId(id) : null;
  const [formData, setFormData] = useState(initialFields);
  const [showLoaderOnClick, setShowLoaderOnClick] = useState(false);
  const [showLoaderOnCity, setShowLoaderOnCity] = useState(false);
  const [showImageModal, setShowImageModal] = useState(false);
  const [open, setOpen] = useState({
    basic: true,
    traineeDetails: false,
    traineeClassification: false,
  });

  const [showAddCityModal, setShowAddCityModal] = useState({ isopen: false, stateName: null, stateID: null });
  const [newCityName, setNewCityName] = useState("");

  const states =
    useSelector((state) => state.channelPartner.states?.data?.states) || [];

  const cities =
    useSelector((state) => state.channelPartner.cities?.data?.cities) || [];

  const channelPartners =
    useSelector(
      (state) => state.channelPartner.channelPartnerList?.data?.channelPartners,
    ) || [];

  useEffect(() => {
    getStates(dispatch);
    if (role !== "CHANNEL_PARTNER") {
      getChannelPartnerList(dispatch);
    }
  }, [dispatch, role]);

  // Prefill form when in edit mode
  useEffect(() => {
    if (mode === "edit") {
      if (!decodedId) {
        notify("danger", "Invalid trainee id");
        navigate(
          role === "SUPER_ADMIN"
            ? "/super-admin/trainee"
            : role === "CHANNEL_PARTNER"
              ? "/channel-partner/trainee"
              : "/admin/trainee",
        );
        return;
      }
      getTraineeDetails(decodedId);
    }
  }, [mode, decodedId]);

  useEffect(() => {
    if (!channelPartners.length || role === "CHANNEL_PARTNER") return;

    const currentValue = formData.channelPartner?.value;

    const channelPartnerId =
      typeof currentValue === "object"
        ? currentValue?.value
        : currentValue;

    if (!channelPartnerId) return;

    const partner = channelPartners.find(
      (item) => Number(item.ID) === Number(channelPartnerId)
    );

    if (!partner) return;

    if (
      typeof currentValue === "object" &&
      Number(currentValue.value) === Number(partner.ID)
    ) {
      return;
    }

    setFormData((prev) => ({
      ...prev,
      channelPartner: {
        ...prev.channelPartner,
        value: {
          label: partner.organizationName,
          value: partner.ID,
        },
      },
    }));
  }, [channelPartners, formData.channelPartner?.value, role]);

  const stateOptions = useMemo(() => {
    return states.map((r) => ({
      value: r.ID,
      label: r.name,
    }));
  }, [states]);

  const cityOptions = useMemo(() => {
    return cities.map((c) => ({
      value: c.ID,
      label: c.name,
    }));
  }, [cities]);

  const formatSections = (sections) => {
    if (sections.length === 1) return sections[0];
    if (sections.length === 2) return sections.join(" and ");

    return `${sections.slice(0, -1).join(", ")} and ${sections.at(-1)}`;
  };

  const fetchCitiesForState = (stateID) => {
    const cityFilter = JSON.stringify([
      {
        field: "StateID",
        condition: "eq",
        filterValues: [String(stateID)],
      },
    ]);

    getCities(dispatch, cityFilter);
  };

  //get the details of trainee by id
  const getTraineeDetails = async (id) => {
    try {
      const res = await getTraineeDetailByID(id);
      const traineeDetails = res?.data;

      if (res?.code === 200) {
        setFormData((prev) => ({
          ...prev,
          firstName: {
            value: traineeDetails?.firstName || "",
            error: "",
            isChanged: false,
          },
          lastName: {
            value: traineeDetails?.lastName || "",
            error: "",
            isChanged: false,
          },
          email: {
            value: traineeDetails?.email || "",
            error: "",
            isChanged: false,
          },
          mobile: {
            value: traineeDetails?.mobile || "",
            error: "",
            isChanged: false,
          },
          dob: {
            value: traineeDetails?.dob
              ? humanReadableToInputDate(traineeDetails?.dob)
              : "",
            error: "",
            isChanged: false,
          },
          profilePhoto: {
            value: null,
            preview: traineeDetails?.profileImagePath || "",
            error: "",
          },
          gender: {
            value:
              GENDER_OPTIONS.find(
                (opt) => opt.value === traineeDetails?.gender,
              ) || null,
            error: "",
            isChanged: false,
          },
          status: {
            value: traineeDetails?.status || "ACTIVE",
            error: "",
            isChanged: false,
          },
          organizationName: {
            value: traineeDetails?.organizationName || "",
            error: "",
            isChanged: false,
          },
          governmentID: {
            value: traineeDetails?.governmentID || "",
            error: "",
            isChanged: false,
          },
          state: {
            value: traineeDetails?.city?.state?.ID || "",
            error: "",
            isChanged: false,
          },
          city: {
            value: traineeDetails?.city?.ID || "",
            error: "",
            isChanged: false,
          },
          addressLine1: {
            value: traineeDetails?.lineOne || "",
            error: "",
            isChanged: false,
          },
          addressLine2: {
            value: traineeDetails?.lineTwo || "",
            error: "",
            isChanged: false,
          },
          landmark: {
            value: traineeDetails?.landmark || "",
            error: "",
            isChanged: false,
          },
          pincode: {
            value: traineeDetails?.pincode || "",
            error: "",
            isChanged: false,
          },
          traineeCategory: {
            value:
              TRAINEE_CATEGORY_OPTIONS.find(
                (opt) => opt.value === traineeDetails?.traineeCategory,
              ) || null,
            error: "",
            isChanged: false,
          },
          traineeType: {
            value:
              TRAINEE_TYPE_OPTIONS.find(
                (opt) => opt.value === traineeDetails?.traineeType,
              ) || null,
            error: "",
            isChanged: false,
          },
          channelPartner: {
            value: traineeDetails?.channelPartnerID || null,
            error: "",
            isChanged: false,
            // value:
            //   channelPartners
            //     ?.map((item) => ({
            //       label: item.organizationName,
            //       value: item.ID,
            //     }))
            //     ?.find(
            //       (opt) => opt.value === traineeDetails?.channelPartnerID,
            //     ) || null,
            // error: "",
            // isChanged: false,
          },
          preRequisitesDocuments: {
            value:
              traineeDetails?.documents?.map((doc) => ({
                id: doc.ID,
                preview: doc.documentPath,
                type: doc.documentPath?.toLowerCase().includes(".pdf")
                  ? "application/pdf"
                  : "image/png",
                name: doc.documentName || "Document",
              })) || [],
            error: "",
          },
        }));
        if (traineeDetails?.city?.state?.ID) {
          fetchCitiesForState(traineeDetails.city.state.ID);
        }
      } else {
        const message = Array.isArray(res?.message)
          ? res.message
            .map((err) => (err.Msg ? err.Msg : JSON.stringify(err)))
            .join(", ")
          : res?.message || "Failed to load Trainee details!";
        notify("danger", message);
      }
    } catch (error) {
      notify("danger", error?.message || "Failed to load Trainee details");
    }
  };

  const handleInputChange = (field, value) => {
    setFormData((prev) => {
      if (field === "traineeType") {
        return {
          ...prev,
          traineeType: {
            ...prev.traineeType,
            value,
            error: "",
            isChanged: true,
          },
          // Only clear organizationName error for non-CHANNEL_PARTNER roles
          organizationName: {
            ...prev.organizationName,
            error: role !== "CHANNEL_PARTNER" && value?.value === "FREELANCER"
              ? ""
              : prev.organizationName.error,
          },
        };
      }
      if (field === "state") {
        return {
          ...prev,
          state: {
            ...prev.state,
            value,
            error: "",
            isChanged: true,
          },
          city: {
            ...prev.city,
            value: null,
            error: "",
            isChanged: false,
          },
          pincode: {
            value: "",
            error: "",
            isChanged: false,
          }
        }
      }

      if (field === "mobile" || field === "pincode") {
        if (!REGEX.ONLY_DIGITS_REGEX.test(value)) {
          return {
            ...prev,
          };
        }
        return {
          ...prev,
          [field]: {
            ...prev[field],
            value,
            error: "",
            isChanged: true,
          },
        };
      }

      return {
        ...prev,
        [field]: {
          ...prev[field],
          value,
          error: "",
          isChanged: true,
        },
      };
    });
  };

  const getValidationError = (name, value) => {
    const trimmedValue = typeof value === "string" ? value.trim() : value;
    switch (name) {
      case "firstName":
        return !trimmedValue
          ? "Please enter first name"
          : !REGEX.TRAINEE_NAME_REGEX.test(value)
            ? "First name must contain only letters and spaces"
            : "";

      case "lastName":
        return !trimmedValue
          ? "Please enter last name"
          : !REGEX.TRAINEE_NAME_REGEX.test(value)
            ? "Last name must contain only letters and spaces"
            : "";

      case "email":
        return !trimmedValue
          ? "Please enter email"
          : !REGEX.EMAIL_REGEX.test(value)
            ? "Please enter a valid email"
            : "";

      case "mobile":
        return !value
          ? "Please enter mobile number"
          : value.length !== 10
            ? "Mobile number must be 10 digits"
            : !REGEX.PHONE_NO_REGEX.test(value)
              ? "Please enter a valid mobile number"
              : "";

      case "profilePhoto":
        if (
          (!value || value.length === 0) &&
          !formData?.profilePhoto?.preview
        ) {
          return "Please upload profile photo";
        }
        return "";

      case "organizationName":
        // For CHANNEL_PARTNER role: organization name is hidden, so skip validation
        if (role === "CHANNEL_PARTNER") {
          return "";
        }

        // For other roles: organization name is required for ORGANIZATION
        if (["RRL", "FREELANCER"].includes(
          formData.traineeCategory.value?.value)) {
          return "";
        }
        if (["ORGANIZATION"].includes(
          formData.traineeCategory.value?.value
        ) && !trimmedValue) {
          return "Please enter organization name";
        }
        return "";

      case "governmentID":
        return !trimmedValue ? "Please enter government ID" : "";

      case "traineeType":
        // For CHANNEL_PARTNER role: trainee type is required
        if (role === "CHANNEL_PARTNER") {
          return !value ? "Please select trainee type" : "";
        }
        // For other roles: trainee type is required except for RRL
        return formData.traineeCategory.value?.value === "RRL"
          ? ""
          : !value
            ? "Please select trainee type"
            : "";

      case "traineeCategory":
        // Only validate for non-CHANNEL_PARTNER roles
        if (role === "CHANNEL_PARTNER") {
          return "";
        }
        return !value ? "Please select trainee category" : "";

      case "channelPartner":
        // Only validate for non-CHANNEL_PARTNER roles
        if (role === "CHANNEL_PARTNER") {
          return "";
        }
        return ["RRL", "FREELANCER", "ORGANIZATION"].includes(
          formData.traineeCategory.value?.value,
        )
          ? ""
          : !value
            ? "Please select channel partner"
            : "";

      case "state":
        return !value ? "Please select state" : "";

      case "city":
        return !value ? "Please select city" : "";

      case "pincode":
        return !value
          ? "Please enter pincode"
          : value.length !== 6
            ? "Pincode must be 6 digits"
            : "";

      case "addressLine1":
        return !trimmedValue ? "Please enter address line 1" : "";

      case "dob": {
        if (!value) {
          return "Please select a valid date of birth";
        }

        const [year, month, day] = value?.split("-").map(Number);

        const dob = new Date(year, month - 1, day);

        if (
          dob.getFullYear() !== year ||
          dob.getMonth() !== month - 1 ||
          dob.getDate() !== day
        ) {
          return "Please enter a valid date";
        }

        const today = new Date();

        if (dob > today) {
          return "Date of birth cannot be in the future";
        }

        let age = today.getFullYear() - year;

        const monthDiff = today.getMonth() - (month - 1);

        if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < day)) {
          age--;
        }

        if (age < 18) {
          return "Trainee must be at least 18 years old";
        }

        return "";
      }
      default:
        return "";
    }
  };

  //on blur to get if any validation error exits
  const handleOnBlur = (name, value) => {
    // For CHANNEL_PARTNER, don't validate hidden fields
    if (role === "CHANNEL_PARTNER" && (name === "traineeCategory" || name === "channelPartner" || name === "organizationName")) {
      return;
    }

    const trimmedValue = typeof value === "string" ? value.trim() : value;
    const error = getValidationError(name, trimmedValue);
    setFormData((prev) => ({
      ...prev,
      [name]: {
        ...prev[name],
        value: trimmedValue,
        error,
      },
    }));
  };

  const validateForm = () => {
    let newTrainee = { ...formData };
    let hasError = false;
    let sectionsToOpen = {
      basic: false,
      traineeDetails: false,
      traineeClassification: false,
    };

    //get all the keys in array
    Object.keys(newTrainee).forEach((key) => {
      newTrainee[key] = {
        ...newTrainee[key],
        error: getValidationError(key, newTrainee[key].value),
      };
    });

    const errorSections = new Set();

    for (const key in newTrainee) {
      if (newTrainee[key].error) {
        hasError = true;

        const section = fieldToSectionMap[key];

        if (section) {
          sectionsToOpen[section] = true;
          errorSections.add(sectionLabels[section]);
        }
      }
    }

    if (hasError) {
      setOpen((prev) => ({
        ...prev,
        ...sectionsToOpen,
      }));
    }

    setFormData(newTrainee);

    return {
      isValid: !hasError,
      errorSections: [...errorSections],
    };
  };

  const getEditedBodyData = (formData) =>
    Object.fromEntries(
      Object.entries(formData)
        .filter(([, field]) => field.isChanged)
        .map(([key, field]) => {
          if (key === "gender") {
            return [key, field.value?.value];
          }

          if (key === "profilePhoto") {
            return [key, field.value];
          }

          return [key, field.value];
        }),
    );

  const handleSave = async () => {
    const { isValid, errorSections } = validateForm();

    if (!isValid) {
      notify(
        "danger",
        `Please complete the required fields in ${formatSections(
          errorSections,
        )} before saving.`,
      );
      return;
    }

    try {
      setShowLoaderOnClick(true);

      await new Promise((resolve) => setTimeout(resolve, 1000));

      const bodyData =
        mode === "edit"
          ? getEditedBodyData(formData)
          : {
            firstName: formData.firstName.value,
            lastName: formData.lastName.value,
            email: formData.email.value,
            mobile: formData.mobile.value,
            status: formData.status.value,
            gender: formData.gender.value?.value || "",
            dob: formData.dob.value,
            profilePhoto: formData.profilePhoto.value,
            organizationName: formData.organizationName.value,
            governmentId: formData.governmentID.value,
          };

      if (mode === "add") {
        const formDataPayload = new FormData();

        // Build the trainee object based on role
        const traineeObject = {
          firstName: formData.firstName.value,
          lastName: formData.lastName.value,
          email: formData.email.value,
          mobile: formData.mobile.value,
          status: formData.status.value,
          gender: formData.gender.value?.value || "",
          dob: formData.dob.value,
          countryID: 1,
          stateID: formData.state.value || null,
          cityID: formData.city.value || null,
          lineOne: formData.addressLine1.value,
          lineTwo: formData.addressLine2.value,
          landmark: formData.landmark.value,
          pincode: formData.pincode.value,
          governmentID: formData.governmentID.value,
          organizationName: formData.organizationName.value,
        };

        // Add role-specific fields
        if (role === "CHANNEL_PARTNER") {
          // For CHANNEL_PARTNER: Only traineeType and organizationName
          traineeObject.traineeType = formData.traineeType.value?.value || "";
          // traineeCategory is not needed for CHANNEL_PARTNER
          // channelPartnerID is not needed as they are the channel partner themselves
        } else {
          // For SUPER_ADMIN and ADMIN: Include all classification fields
          traineeObject.organizationName = formData.organizationName.value;
          traineeObject.traineeCategory = formData.traineeCategory.value?.value || "";
          traineeObject.traineeType = formData.traineeType.value?.value || "";
          traineeObject.channelPartnerID = formData.channelPartner.value?.value || null;
          if (formData.traineeCategory.value?.value === "THIRD_PARTY_CONTRACTOR") {
            traineeObject.organizationName = formData.channelPartner.value?.label
          }
        }

        formDataPayload.append("trainee", JSON.stringify(traineeObject));

        if (formData.profilePhoto.value instanceof File) {
          formDataPayload.append("profilePhoto", formData.profilePhoto.value);
        }

        formData.preRequisitesDocuments.value.forEach((item) => {
          if (item.file) {
            formDataPayload.append("prerequisitesDocument", item.file);
          }
        });

        const res = await addTrainee(formDataPayload);

        if (res?.code === 200) {
          notify("success", res?.message || "Trainee added successfully");
          navigate(
            role === "SUPER_ADMIN"
              ? "/super-admin/trainee"
              : role === "CHANNEL_PARTNER"
                ? "/channel-partner/trainee"
                : "/admin/trainee",
          );
        } else {
          const message = Array.isArray(res?.message)
            ? res.message
              .map((err) => (err?.Msg ? err.Msg : JSON.stringify(err)))
              .join(", ")
            : res?.message || "Failed to add trainee";
          notify("danger", message);
        }
      } else {
        const { profilePhoto, ...rest } = bodyData;

        const hasNewDocuments = formData.preRequisitesDocuments.value.some(
          (item) => item.file,
        );

        const hasDeletedDocuments =
          formData.deletedDocumentIds.value.length > 0;

        const hasProfilePhotoChange =
          profilePhoto instanceof File || formData.deleteProfilePhoto.value;

        if (
          Object.keys(bodyData).length === 0 &&
          !hasNewDocuments &&
          !hasDeletedDocuments &&
          !hasProfilePhotoChange
        ) {
          notify("info", "No changes detected");
          return;
        }

        const formDataPayload = new FormData();

        const editedPayload = {
          ...rest,

          ...(formData.state.isChanged && {
            stateID: formData.state.value || null,
          }),
          ...(formData.city.isChanged && {
            cityID: formData.city.value || null,
          }),
          ...(formData.addressLine1.isChanged && {
            lineOne: formData.addressLine1.value || "",
          }),
          ...(formData.addressLine2.isChanged && {
            lineTwo: formData.addressLine2.value || "",
          }),
        };

        // Add role-specific fields for edit mode
        if (role === "CHANNEL_PARTNER") {
          if (formData.traineeType.isChanged) {
            editedPayload.traineeType = formData.traineeType.value?.value || "";
          }
          if (formData.organizationName.isChanged) {
            editedPayload.organizationName = formData.organizationName.value;
          }
        } else {
          if (formData.traineeCategory.isChanged) {
            editedPayload.traineeCategory = formData.traineeCategory.value?.value || "";
            if (formData.traineeCategory.value?.value === "THIRD_PARTY_CONTRACTOR") {
              editedPayload.organizationName = formData.channelPartner.value?.label;
              editedPayload.traineeType = formData.traineeType.value?.value;
            }
            if (formData.traineeCategory.value?.value === "ORGANIZATION") {
              editedPayload.organizationName = formData.organizationName.value;
              editedPayload.traineeType = formData.traineeType.value?.value;
            }
            if (formData.traineeCategory.value?.value === "FREELANCER") {
              editedPayload.traineeType = formData.traineeType.value?.value;
            }
          }
          if (formData.traineeType.isChanged) {
            editedPayload.traineeType = formData.traineeType.value?.value || "";
          }
          if (formData.channelPartner.isChanged) {
            editedPayload.channelPartnerID = formData.channelPartner.value?.value || "";
          }
          if (formData.organizationName.isChanged) {
            editedPayload.organizationName = formData.organizationName.value;
          }
        }

        formDataPayload.append("trainee", JSON.stringify(editedPayload));

        if (profilePhoto instanceof File) {
          formDataPayload.append("profilePhoto", profilePhoto);
        }

        formData.preRequisitesDocuments.value.forEach((item) => {
          if (item.file) {
            formDataPayload.append("prerequisitesDocument", item.file);
          }
        });

        if (formData.deleteProfilePhoto.value) {
          formDataPayload.append("deleteProfilePhoto", "true");
        }

        if (formData.deletedDocumentIds.value.length > 0) {
          formDataPayload.append(
            "deletedDocumentIds",
            JSON.stringify(formData.deletedDocumentIds.value),
          );
        }

        const res = await editTrainee(decodedId, formDataPayload);

        if (res?.code === 200) {
          notify("success", res?.message || "Trainee updated successfully");
          navigate(
            role === "SUPER_ADMIN"
              ? `/super-admin/trainee/${id}/details`
              : role === "CHANNEL_PARTNER"
                ? `/channel-partner/trainee/${id}/details`
                : `/admin/trainee/${id}/details`,
          );
        } else {
          const message = Array.isArray(res?.message)
            ? res.message
              .map((err) => (err?.Msg ? err.Msg : JSON.stringify(err)))
              .join(", ")
            : res?.message || "Failed to edit trainee";
          notify("danger", message);
        }
      }
    } catch (e) {
      notify("danger", "Something went wrong");
    } finally {
      setShowLoaderOnClick(false);
    }
  };

  const handleImageChange = (file) => {
    if (!file) return;

    // size validation
    if (file.size > MAX_PHOTO_SIZE) {
      notify("danger", "Please upload a profile photo smaller than 5 MB.");
      return;
    }

    setFormData((prev) => ({
      ...prev,
      profilePhoto: {
        value: file,
        preview: URL.createObjectURL(file),
        error: "",
        isChanged: true,
      },
      deleteProfilePhoto: {
        value: false,
        error: "",
      },
    }));
  };

  const handleOnCancel = () => {
    setFormData(initialFields);
    // navigate("/admin/trainee");
    navigate(
      mode === "edit"
        ? role === "SUPER_ADMIN"
          ? `/super-admin/trainee/${id}/details`
          : role === "CHANNEL_PARTNER"
            ? `/channel-partner/trainee/${id}/details`
            : `/admin/trainee/${id}/details`
        : role === "SUPER_ADMIN"
          ? "/super-admin/trainee"
          : role === "CHANNEL_PARTNER"
            ? "/channel-partner/trainee"
            : "/admin/trainee",
    );
  };

  const handleBack = () => {
    navigate(
      mode === "edit"
        ? role === "SUPER_ADMIN"
          ? `/super-admin/trainee/${id}/details`
          : role === "CHANNEL_PARTNER"
            ? `/channel-partner/trainee/${id}/details`
            : `/admin/trainee/${id}/details`
        : role === "SUPER_ADMIN"
          ? "/super-admin/trainee"
          : role === "CHANNEL_PARTNER"
            ? "/channel-partner/trainee"
            : "/admin/trainee",
    )
  };

  // const removeDocument = (index) => {
  //   setFormData((prev) => {
  //     const removedDoc = prev.preRequisitesDocuments.value[index];

  //     return {
  //       ...prev,

  //       preRequisitesDocuments: {
  //         value: prev.preRequisitesDocuments.value.filter(
  //           (_, i) => i !== index,
  //         ),
  //         error: "",
  //       },

  //       deletedDocumentIds: {
  //         value: removedDoc?.id
  //           ? [...prev.deletedDocumentIds.value, removedDoc.id]
  //           : prev.deletedDocumentIds.value,
  //         error: "",
  //       },
  //     };
  //   });
  // };

  // const handleDocsChange = (e) => {
  //   const files = Array.from(e.target.files);

  //   const oversizedFile = files.find(
  //     (file) => file.size > MAX_DOCUMENT_SIZE
  //   );

  //   if (oversizedFile) {
  //     notify(
  //       "danger",
  //       `File size should be less than 15MB`
  //     );
  //     e.target.value = "";
  //     return;
  //   }

  //   const newFiles = files
  //     .filter(
  //       (file) =>
  //         file.type.startsWith("image/") || file.type === "application/pdf",
  //     )
  //     .map((file) => ({
  //       file,
  //       preview: file.type.startsWith("image/")
  //         ? URL.createObjectURL(file)
  //         : null,
  //       name: file.name,
  //       type: file.type,
  //     }));

  //   setFormData((prev) => {
  //     const updatedFiles = [
  //       ...prev.preRequisitesDocuments.value,
  //       ...newFiles,
  //     ].slice(0, 15); // for now we are considering max 15

  //     return {
  //       ...prev,
  //       preRequisitesDocuments: {
  //         value: updatedFiles,
  //         error: "",
  //       },
  //     };
  //   });

  //   e.target.value = "";
  // };

  const toggle = (key) => {
    setOpen((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  const SectionHeader = ({ title, isOpen, onClick }) => (
    <div className="d-flex align-items-center cursor" onClick={onClick}>
      <i className={`fa fa-chevron-${isOpen ? "up" : "down"} text-default`} />
      <h5 className="ml-2 mb-0 section-header-title">{title}</h5>
    </div>
  );

  const maxDOB = new Date(
    new Date().getFullYear() - 18,
    new Date().getMonth(),
    new Date().getDate()
  )
    .toISOString()
    .split("T")[0];

  const handleOpenCityModal = () => {
    setShowAddCityModal({ isopen: true, stateID: formData.state.value, stateName: stateOptions.find((s) => s.value === formData.state.value)?.label });
  }

  const handleSaveNewCity = async (stateID) => {
    setShowLoaderOnCity(true);
    try {
      const res = await addCity({
        stateID: stateID,
        name: newCityName,
        status: "ACTIVE"
      })
      if (res?.code === 200) {
        notify("success", res?.message || "City added successfully");
        fetchCitiesForState(stateID);
        setShowAddCityModal({ isopen: false, stateID: null, stateName: null });
        setNewCityName("")
      } else {
        const message = Array.isArray(res?.message)
          ? res.message
            .map((err) => (err.Msg ? err.Msg : JSON.stringify(err)))
            .join(", ")
          : res?.message || "Failed to add city";
        notify("danger", message);
      }
    } catch (error) {
      notify("danger", error?.message || "Failed to add city");
    } finally {
      setShowLoaderOnCity(false);
    }
  }

  const handleCancelAddCity = () => {
    setShowAddCityModal({ isopen: false, stateID: null, stateName: null });
    setNewCityName("")
  }

  const channelPartnerOptions = channelPartners
    .filter((partner) => partner.userID?.status === "ACTIVE")
    .map((partner) => ({
      label: partner.organizationName,
      value: partner.ID,
    }));

  return (
    <>
      <AdminHeader />
      {(showLoaderOnClick) && (
        <div className="logout-overlay">
          <div className="logout-card">
            <i className="fa fa-spinner fa-spin fa-2x text-deep-blue mb-4" />
            <div className="font-weight-bold text-dark">
              Saving information... Please wait.
            </div>
          </div>
        </div>
      )}
      <Container fluid className="mt--6">
        <Row className="justify-content-center">
          <Col>
            <div
              className="d-flex align-items-center cursor text-white"
              onClick={() => handleBack()}
            >
              <i className="fa-solid fa-angle-left mr-2" />
              <span className="font-weight-bold">
                {mode === "edit" ? "Edit Trainee" : "Back"}
              </span>

              {/* <h3 className="mb-0">
                {mode === "edit" ? "Edit Instructor" : "Add Instructor"}
              </h3> */}
            </div>

            <Card className="mb-3 mt-3">
              <CardHeader>
                <SectionHeader
                  title="Basic Information"
                  isOpen={open.basic}
                  onClick={() => toggle("basic")}
                />
              </CardHeader>

              <Collapse isOpen={open.basic}>
                <CardBody>
                  <Row>
                    <Col md="4" sm="12">
                      <FormGroup>
                        <Label className="form-control-label">First Name</Label>
                        <span className="text-danger"> *</span>
                        <Input
                          type="text"
                          name="firstName"
                          placeholder="Enter first name"
                          value={formData.firstName.value}
                          onChange={(e) =>
                            handleInputChange("firstName", e.target.value)
                          }
                          onBlur={(e) =>
                            handleOnBlur(e.target.name, e.target.value)
                          }
                          className={
                            formData.firstName.error ? "is-invalid" : ""
                          }
                          maxLength={50}
                        />
                        {formData.firstName.error && (
                          <div className="invalid-feedback d-block">
                            {formData.firstName.error}
                          </div>
                        )}
                      </FormGroup>
                    </Col>

                    <Col md="4" sm="12">
                      <FormGroup>
                        <Label className="form-control-label">Last Name</Label>
                        <span className="text-danger"> *</span>
                        <Input
                          type="text"
                          name="lastName"
                          placeholder="Enter last name"
                          value={formData.lastName.value}
                          onChange={(e) =>
                            handleInputChange("lastName", e.target.value)
                          }
                          onBlur={(e) =>
                            handleOnBlur(e.target.name, e.target.value)
                          }
                          className={
                            formData.lastName.error ? "is-invalid" : ""
                          }
                          maxLength={50}
                        />
                        {formData.lastName.error && (
                          <div className="invalid-feedback d-block">
                            {formData.lastName.error}
                          </div>
                        )}
                      </FormGroup>
                    </Col>

                    <Col md="4" sm="12">
                      <FormGroup>
                        <Label className="form-control-label">Email</Label>
                        <span className="text-danger"> *</span>
                        <Input
                          type="email"
                          name="email"
                          placeholder="Enter email"
                          value={formData.email.value}
                          onChange={(e) =>
                            handleInputChange("email", e.target.value)
                          }
                          onBlur={(e) =>
                            handleOnBlur(e.target.name, e.target.value)
                          }
                          className={formData.email.error ? "is-invalid" : ""}
                          maxLength={100}
                        />
                        {formData.email.error && (
                          <div className="invalid-feedback d-block">
                            {formData.email.error}
                          </div>
                        )}
                      </FormGroup>
                    </Col>
                  </Row>

                  <Row>
                    <Col md="4" sm="12">
                      <FormGroup>
                        <Label className="form-control-label">
                          Mobile Number
                        </Label>
                        <span className="text-danger"> *</span>
                        <Input
                          placeholder="Enter mobile number"
                          name="mobile"
                          maxLength={10}
                          value={formData.mobile.value}
                          onChange={(e) =>
                            handleInputChange("mobile", e.target.value)
                          }
                          onBlur={(e) =>
                            handleOnBlur(e.target.name, e.target.value)
                          }
                          className={formData.mobile.error ? "is-invalid" : ""}
                        />

                        {formData.mobile.error && (
                          <div className="invalid-feedback d-block">
                            {formData.mobile.error}
                          </div>
                        )}
                      </FormGroup>
                    </Col>
                    <Col md="4" sm="12">
                      <FormGroup>
                        <Label className="form-control-label">
                          Date of Birth
                        </Label>
                        <span className="text-danger"> *</span>
                        <DatePicker
                          selected={formData.dob.value}
                          onChange={(date) =>
                            handleInputChange(
                              "dob",
                              date ? format(date, "yyyy-MM-dd") : "",
                            )
                          }
                          onBlur={() => handleOnBlur("dob", formData.dob.value)}
                          dateFormat="dd-MMM-yyyy"
                          placeholderText="Select date of birth"
                          showMonthDropdown
                          showYearDropdown
                          scrollableYearDropdown
                          yearDropdownItemNumber={100}
                          maxDate={maxDOB}
                          showIcon
                          icon={
                            <i className="fa-solid fa-calendar-day fa-md mt-1 mr-4 text-muted" />
                          }
                          toggleCalendarOnIconClick
                          className={`form-control ${formData.dob.error ? "is-invalid" : ""
                            }`}
                          wrapperClassName="w-100"
                          calendarClassName="custom-calendar"
                          popperPlacement="bottom-start"
                          onKeyDown={(e) => e.preventDefault()}
                          onPaste={(e) => e.preventDefault()}
                        />
                        {formData.dob.error && (
                          <div className="invalid-feedback d-block">
                            {formData.dob.error}
                          </div>
                        )}
                      </FormGroup>
                    </Col>

                    <Col md="4" sm="12">
                      <FormGroup>
                        <Label className="form-control-label">
                          Government ID <span className="text-danger"> *</span>
                        </Label>

                        <Input
                          type="text"
                          name="governmentID"
                          placeholder="Enter government ID"
                          value={formData.governmentID.value}
                          onChange={(e) =>
                            handleInputChange("governmentID", e.target.value)
                          }
                          maxLength={30}
                          onBlur={(e) =>
                            handleOnBlur(e.target.name, e.target.value)
                          }
                          className={
                            formData.governmentID.error ? "is-invalid" : ""
                          }
                        />
                        {formData.governmentID.error && (
                          <div className="invalid-feedback d-block">
                            {formData.governmentID.error}
                          </div>
                        )}
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    {/* <Col md="6" sm="12">
                      <FormGroup>
                        <Label className="form-control-label">Role</Label>
                        <Select
                          options={ROLE_OPTIONS}
                          styles={SELECT_CUSTOM_STYLES}
                          placeholder="Select role"
                          classNamePrefix="react-select"
                          value={formData.role.value || null}
                          onChange={(selected) =>
                            handleInputChange("role", selected)
                          }
                          menuPortalTarget={document.body}
                          menuPosition="absolute"
                          onBlur={(e) =>
                            handleOnBlur(e.target.name, e.target.value)
                          }
                        />
                      </FormGroup>
                    </Col>

                    <Col md="6" sm="12">
                      <FormGroup>
                        <Label className="form-control-label">
                          Login Method
                        </Label>
                        <Select
                          options={LOGIN_METHOD}
                          placeholder="Select login method"
                          styles={SELECT_CUSTOM_STYLES}
                          value={formData.loginMethod.value || null}
                          onChange={(selected) =>
                            handleInputChange("loginMethod", selected)
                          }
                          menuPortalTarget={document.body}
                          menuPosition="absolute"
                        />
                      </FormGroup>
                    </Col> */}

                    <Col md="4" sm="12">
                      <FormGroup className="profile-photo-container mt-0">
                        <Label className="form-control-label">
                          Profile Photo <span className="text-danger"> *</span>

                        </Label>

                        <div
                          className={`profile-photo-upload text-center rounded p-3 ${formData.profilePhoto.error ? "profile-invalid" : "border"}`}
                        >
                          {formData.profilePhoto.value ||
                            formData.profilePhoto.preview ? (
                            <div className="position-relative d-inline-block">


                              <img
                                src={
                                  formData.profilePhoto.value
                                    ? URL.createObjectURL(
                                      formData.profilePhoto.value,
                                    )
                                    : formData.profilePhoto.preview
                                }
                                alt="Profile Preview"
                                className="profile-photo-preview cursor"
                                onClick={() => setShowImageModal(true)}
                              />

                              <span
                                className="remove-image"
                                onClick={() =>
                                  setFormData((prev) => ({
                                    ...prev,

                                    profilePhoto: {
                                      value: null,
                                      preview: "",
                                      error: "",
                                      isChanged: true,
                                    },

                                    deleteProfilePhoto: {
                                      value: true,
                                      error: "",
                                    },
                                  }))
                                }
                              >
                                &times;
                              </span>
                            </div>
                          ) : (
                            <div className="d-flex flex-column align-items-center">
                              <i className="fa fa-cloud-upload fa-2x text-muted mb-2"></i>
                              <p className="mb-0 mt-1 muted-label font-size-sm">
                                (Accepted formats: PNG, JPG, JPEG - Max 5MB)
                              </p>
                              <p className="mb-1 muted-label font-size-sm">
                                Click to upload profile image
                              </p>
                              <Label
                                for="profilePhoto"
                                className="choose-image-btn btn btn-simple btn-sm mt-2"
                              >
                                Choose Image
                              </Label>
                            </div>
                          )}

                          <Input
                            type="file"
                            id="profilePhoto"
                            name="profilePhoto"
                            accept="image/*"
                            className="d-none"
                            onChange={(e) =>
                              handleImageChange(e.target.files[0])
                            }
                          />
                        </div>
                        {formData.profilePhoto.error && (
                          <div className="invalid-feedback d-block">
                            {formData.profilePhoto.error}
                          </div>
                        )}
                      </FormGroup>
                    </Col>

                    <Col md="4" sm="12">
                      <FormGroup>
                        <Label className="form-control-label">Gender</Label>
                        <Select
                          options={GENDER_OPTIONS}
                          styles={SELECT_CUSTOM_STYLES}
                          placeholder="Select gender"
                          classNamePrefix="react-select"
                          value={formData.gender.value || null}
                          onChange={(selected) =>
                            handleInputChange("gender", selected)
                          }
                          menuPortalTarget={document.body}
                          menuPosition="absolute"
                          onBlur={(e) =>
                            handleOnBlur(e.target.name, e.target.value)
                          }
                          isClearable
                        />
                      </FormGroup>
                    </Col>

                    <Col md="4" sm="12">
                      <FormGroup>
                        <Label className="form-control-label">
                          Status <span className="text-danger"> *</span>
                        </Label>

                        <div className="d-flex mt-2">
                          <FormGroup check className="mr-4">
                            <Label check>
                              <Input
                                type="radio"
                                name="status"
                                className="cursor"
                                checked={formData.status.value === "ACTIVE"}
                                onChange={() =>
                                  handleInputChange("status", "ACTIVE")
                                }
                              />
                              Active
                            </Label>
                          </FormGroup>

                          <FormGroup check>
                            <Label check>
                              <Input
                                type="radio"
                                name="status"
                                className="cursor"
                                checked={formData.status.value === "INACTIVE"}
                                onChange={() =>
                                  handleInputChange("status", "INACTIVE")
                                }
                              />
                              Inactive
                            </Label>
                          </FormGroup>
                        </div>
                      </FormGroup>

                    </Col>

                  </Row>
                  {/*<Row>
                     <Col md={8} sm={12}>
                      <FormGroup>
                        <Label className="form-control-label mb--1 mt-2">
                          Prerequisites Documents{" "}
                          <span className="text-muted d-block font-weight-normal">
                            (Accepted formats: PDF, PNG, JPG - Max 15 MB)
                          </span>
                        </Label>

                        <div className="prerequisite-document-upload w-100 p-3 border rounded text-center cursor">
                          {formData.preRequisitesDocuments.value.length > 0 ? (
                            <div className="d-flex flex-wrap align-items-start">
                              {formData.preRequisitesDocuments.value.map(
                                (item, index) => {
                                  const isString = typeof item === "string";
                                  const isPdf = isString
                                    ? item.toLowerCase().endsWith(".pdf")
                                    : item.type === "application/pdf";

                                  // src for images: if string assume backend/public path, otherwise use preview created via URL.createObjectURL
                                  const imgSrc = isString
                                    ? `/uploads/${item}`
                                    : item.preview;

                                  return (
                                    <div
                                      key={index}
                                      className="position-relative mr-3 mb-3"
                                    >
                                      <div className="doc-preview-container">
                                        <div className="doc-preview">
                                          {isPdf ? (
                                            <div className="pdf-preview">
                                              <i className="fa fa-file-pdf text-danger fa-4x"></i>
                                            </div>
                                          ) : (
                                            <img
                                              src={imgSrc}
                                              className="doc-image"
                                              alt="Document"
                                            />
                                          )}
                                        </div> */}
                  {/* <div className="doc-actions">
                                          <Button
                                            color="link"
                                            size="sm"
                                            className="doc-action-btn"
                                            title="View"
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              // handleViewFile(imgSrc);
                                            }}
                                          >
                                            <i className="fa fa-eye mr-5" />{" "}
                                          </Button>
                                        </div> */}
                  {/* </div>

                                      <span
                                        className="remove-image"
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          removeDocument(index);
                                        }}
                                      >
                                        &times;
                                      </span>
                                    </div>
                                  );
                                },
                              )} */}

                  {/* Add more only if less than 5 */}
                  {/* //for now we are consider max 5 */}
                  {/* {formData.preRequisitesDocuments.value.length <
                                15 && (
                                  <div
                                    className="add-more-container"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      document
                                        .getElementById("preRequisitesDoc")
                                        .click();
                                    }}
                                  >
                                    <div className="add-more-file-wrapper">+</div>
                                    <span className="small">Add more</span>
                                  </div>
                                )}
                            </div>
                          ) : (
                            <div className="d-flex flex-column align-items-center">
                              <i className="fa fa-cloud-upload fa-2x text-muted mb-2" />
                              <p className="mb-1 text-muted">
                                Click to upload documents
                              </p>
                              <Label
                                for="preRequisitesDoc"
                                className="btn btn-sm btn-color choose-image-btn btn-simple mt-2"
                              // onClick={(e) => {
                              //   e.stopPropagation();
                              //   document
                              //     .getElementById("preRequisitesDoc")
                              //     .click();
                              // }}
                              >
                                Choose Files
                              </Label>
                            </div>
                          )}
                        </div>*/}

                  {/* Hidden Input */}
                  {/* <Input
                          type="file"
                          id="preRequisitesDoc"
                          multiple
                          accept="image/*,application/pdf"
                          className="d-none"
                          onClick={(e) => e.stopPropagation()}
                          onChange={handleDocsChange}
                        />
                      </FormGroup>
                    </Col>  
                  </Row>*/}
                </CardBody>
              </Collapse>
            </Card>

            <Card className="mb-3 mt-3">
              <CardHeader>
                <SectionHeader
                  title="Address Details"
                  isOpen={open.traineeDetails}
                  onClick={() => toggle("traineeDetails")}
                />
              </CardHeader>

              <Collapse isOpen={open.traineeDetails}>
                <CardBody>
                  <Row>
                    <Col md="4">
                      <FormGroup>
                        <Label className="form-control-label">
                          Address Line 1 <span className="text-danger"> *</span>
                        </Label>
                        <Input
                          type="textarea"
                          rows="1"
                          name="addressLine1"
                          placeholder="Enter flat / building / street"
                          value={formData.addressLine1.value}
                          onChange={(e) =>
                            handleInputChange("addressLine1", e.target.value)
                          }
                          onBlur={(e) =>
                            handleOnBlur(e.target.name, e.target.value)
                          }
                          className={
                            formData.addressLine1.error
                              ? "is-invalid address-textarea"
                              : "address-textarea"
                          }
                          maxLength={150}
                        />
                        {formData.addressLine1.error && (
                          <div className="invalid-feedback d-block">
                            {formData.addressLine1.error}
                          </div>
                        )}
                      </FormGroup>
                    </Col>

                    <Col md="4">
                      <FormGroup>
                        <Label className="form-control-label">
                          Address Line 2
                        </Label>
                        <Input
                          type="textarea"
                          rows="1"
                          name="addressLine2"
                          placeholder="Enter area / locality"
                          value={formData.addressLine2.value}
                          onChange={(e) =>
                            handleInputChange("addressLine2", e.target.value)
                          }
                          onBlur={(e) =>
                            handleOnBlur(e.target.name, e.target.value)
                          }
                          maxLength={150}
                        />
                      </FormGroup>
                    </Col>

                    <Col md="4">
                      <FormGroup>
                        <Label className="form-control-label">Landmark</Label>
                        <Input
                          type="textarea"
                          rows="1"
                          name="landmark"
                          placeholder="Enter nearby landmark"
                          value={formData.landmark.value}
                          onChange={(e) =>
                            handleInputChange("landmark", e.target.value)
                          }
                          onBlur={(e) =>
                            handleOnBlur(e.target.name, e.target.value)
                          }
                          maxLength={150}
                        />
                      </FormGroup>
                    </Col>

                    <Col md="4" sm="12">
                      <FormGroup>
                        <Label className="form-control-label">State</Label>
                        <span className="text-danger"> *</span>
                        <Select
                          options={stateOptions}
                          placeholder="Select state"
                          classNamePrefix="react-select"
                          value={stateOptions.find(
                            (opt) => opt.value === formData.state.value,
                          )}
                          onChange={(selected) => {
                            handleInputChange("state", selected?.value || null);
                            if (selected) {
                              fetchCitiesForState(selected.value);
                            }
                          }}
                          styles={SELECT_CUSTOM_STYLES}
                          menuPortalTarget={document.body}
                          menuPosition="absolute"
                          className={formData.state.error ? "is-invalid" : ""}
                          isClearable
                        />
                        {formData.state.error && (
                          <div className="invalid-feedback d-block">
                            {formData.state.error}
                          </div>
                        )}
                      </FormGroup>
                    </Col>

                    <Col md="4" sm="12">
                      <FormGroup>
                        <Label className="form-control-label">City</Label>
                        <span className="text-danger"> *</span>
                        <CreatableSelect
                          placeholder="Select city"
                          options={cityOptions}
                          value={formData.city.value}
                          onChange={(selected) =>
                            handleInputChange("city", selected?.value || null)
                          }
                          isDisabled={!formData.state.value}
                          onAddNew={() => handleOpenCityModal()}
                          className={formData.city.error ? "is-invalid" : ""}
                        />
                        {formData.city.error && (
                          <div className="invalid-feedback d-block">
                            {formData.city.error}
                          </div>
                        )}
                      </FormGroup>
                    </Col>

                    <Col md="4" sm="12">
                      <FormGroup>
                        <Label className="form-control-label">Pin code</Label>
                        <span className="text-danger"> *</span>
                        <Input
                          type="text"
                          name="pincode"
                          placeholder="Enter pincode"
                          value={formData.pincode.value}
                          maxLength={6}
                          disabled={!formData.city.value}
                          onChange={(e) =>
                            handleInputChange("pincode", e.target.value)
                          }
                          onBlur={(e) =>
                            handleOnBlur(e.target.name, e.target.value)
                          }
                          className={formData.pincode.error ? "is-invalid" : ""}
                        />
                        {formData.pincode.error && (
                          <div className="invalid-feedback d-block">
                            {formData.pincode.error}
                          </div>
                        )}
                      </FormGroup>
                    </Col>
                  </Row>
                </CardBody>
              </Collapse>
            </Card>

            <Card className="mt-3">
              <CardHeader>
                <SectionHeader
                  title="Trainee Classification"
                  isOpen={open.traineeClassification}
                  onClick={() => toggle("traineeClassification")}
                />
              </CardHeader>

              <Collapse isOpen={open.traineeClassification}>
                <CardBody>
                  <Row>
                    {role !== "CHANNEL_PARTNER" && <Col md="4" sm="12">
                      <FormGroup>
                        <Label className="form-control-label">
                          Trainee Category{" "}
                          <span className="text-danger"> *</span>
                        </Label>
                        <Select
                          options={TRAINEE_CATEGORY_OPTIONS}
                          styles={SELECT_CUSTOM_STYLES}
                          className={
                            formData.traineeCategory.error ? "is-invalid" : ""
                          }
                          placeholder="Select trainee category"
                          classNamePrefix="react-select"
                          value={formData.traineeCategory.value || null}
                          onChange={(selected) =>
                            handleInputChange("traineeCategory", selected)
                          }
                          onBlur={() =>
                            handleOnBlur(
                              "traineeCategory",
                              formData.traineeCategory.value,
                            )
                          }
                          menuPortalTarget={document.body}
                          menuPosition="absolute"
                          isClearable
                        />
                        {formData.traineeCategory.error && (
                          <div className="invalid-feedback d-block">
                            {formData.traineeCategory.error}
                          </div>
                        )}
                      </FormGroup>
                    </Col>}
                    {formData.traineeCategory.value?.value !== "RRL" && (
                      <>
                        <Col md="4" sm="12">
                          <FormGroup>
                            <Label className="form-control-label">
                              Trainee Type{" "}
                              <span className="text-danger">*</span>
                            </Label>
                            <Select
                              options={TRAINEE_TYPE_OPTIONS}
                              styles={SELECT_CUSTOM_STYLES}
                              placeholder="Select trainee type"
                              className={
                                formData.traineeType.error ? "is-invalid" : ""
                              }
                              classNamePrefix="react-select"
                              value={formData.traineeType.value || null}
                              onChange={(selected) =>
                                handleInputChange("traineeType", selected)
                              }
                              onBlur={() =>
                                handleOnBlur(
                                  "traineeType",
                                  formData.traineeType.value,
                                )
                              }
                              menuPortalTarget={document.body}
                              menuPosition="absolute"
                              isClearable
                            />
                            {formData.traineeType.error && (
                              <div className="invalid-feedback d-block">
                                {formData.traineeType.error}
                              </div>
                            )}
                          </FormGroup>
                        </Col>

                        {(
                          formData.traineeCategory.value?.value !== "FREELANCER" &&
                          role !== "CHANNEL_PARTNER"
                        ) && (
                            <>
                              {formData.traineeCategory.value?.value !== "ORGANIZATION" &&
                                <Col md="4" sm="12">
                                  <FormGroup>
                                    <Label className="form-control-label">
                                      Channel Partner{" "}
                                      <span className="text-danger">*</span>
                                    </Label>

                                    <Select
                                      options={channelPartnerOptions}
                                      styles={SELECT_CUSTOM_STYLES}
                                      placeholder="Select channel partner"
                                      className={
                                        formData.channelPartner.error ? "is-invalid" : ""
                                      }
                                      classNamePrefix="react-select"
                                      value={formData.channelPartner.value || null}
                                      onChange={(selected) =>
                                        handleInputChange("channelPartner", selected)
                                      }
                                      onBlur={() =>
                                        handleOnBlur(
                                          "channelPartner",
                                          formData.channelPartner.value
                                        )
                                      }
                                      menuPortalTarget={document.body}
                                      menuPosition="absolute"
                                      isClearable
                                    />

                                    {formData.channelPartner.error && (
                                      <div className="invalid-feedback d-block">
                                        {formData.channelPartner.error}
                                      </div>
                                    )}
                                  </FormGroup>
                                </Col>}

                              {formData.traineeCategory.value?.value !== "THIRD_PARTY_CONTRACTOR" && <Col md="4" sm="12">
                                <FormGroup>
                                  <Label className="form-control-label">
                                    Organization Name{" "}
                                    {(
                                      formData.traineeCategory.value?.value === "ORGANIZATION" ||
                                      formData.traineeCategory.value?.value ===
                                      "THIRD_PARTY_CONTRACTOR"
                                    ) && <span className="text-danger">*</span>}
                                  </Label>

                                  <Input
                                    type="textarea"
                                    rows="1"
                                    name="organizationName"
                                    placeholder="Enter organization name"
                                    value={formData.organizationName.value}
                                    onChange={(e) =>
                                      handleInputChange(
                                        "organizationName",
                                        e.target.value
                                      )
                                    }
                                    maxLength={100}
                                    onBlur={(e) =>
                                      handleOnBlur(e.target.name, e.target.value)
                                    }
                                    className={
                                      formData.organizationName.error
                                        ? "is-invalid"
                                        : ""
                                    }
                                  />

                                  {formData.organizationName.error && (
                                    <div className="invalid-feedback d-block">
                                      {formData.organizationName.error}
                                    </div>
                                  )}
                                </FormGroup>
                              </Col>}
                            </>
                          )}
                      </>
                    )}
                  </Row>
                </CardBody>
              </Collapse>
            </Card>

            <Row className="mt-5 mr-4 mb-6">
              <Col className="text-right">
                <Button
                  color="secondary"
                  className="mr-2 save-btn-sm"
                  type="button"
                  onClick={handleOnCancel}
                  disabled={showLoaderOnClick}
                >
                  Cancel
                </Button>

                <Button
                  color="primary"
                  className="btn-deep-blue mr-2 save-btn-sm"
                  type="button"
                  onClick={handleSave}
                  disabled={showLoaderOnClick}
                >
                  Save
                  {/* {showLoaderOnClick ? (
                    <>
                      <i className="fa fa-spinner fa-spin mr-2"></i>
                    </>
                  ) : (
                    "Save"
                  )} */}
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
      <Modal
        isOpen={showImageModal}
        toggle={() => setShowImageModal(false)}
        centered
        size="lg"
      >
        <ModalHeader toggle={() => setShowImageModal(false)}>
          Profile Photo Preview
        </ModalHeader>
        <ModalBody className="text-center">
          <img
            src={
              formData.profilePhoto.value
                ? URL.createObjectURL(formData.profilePhoto.value)
                : formData.profilePhoto.preview
            }
            alt="Profile Preview"
            className="img-fluid modal-preview-media"
          />
        </ModalBody>
      </Modal>
      {showAddCityModal && (
        <AddNewCityModal
          isOpen={showAddCityModal.isopen}
          stateID={showAddCityModal.stateID}
          stateName={showAddCityModal.stateName}
          cityName={newCityName}
          setCityName={setNewCityName}
          onSave={handleSaveNewCity}
          onCancel={handleCancelAddCity}
          showLoader={showLoaderOnCity}
        />
      )}
    </>
  );
}

export default AddTrainee;
